import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Modal from 'components/Modal/Modal'

import { findBlocksWithKeyValue } from 'utils/blocks'

import { ProjectContext } from '../../../../contexts/projectContext'

import { BLOCK_DICTIONARY, SCHEMA_KEY } from '../../schema'

import styles from './RewardableBlocksModal.module.scss'

const VIEW = {
    ONE_BLOCK: 'ONE_BLOCK',
    NO_BLOCKS: 'NO_BLOCKS',
    MANY_BLOCKS: 'MANY_BLOCKS',
}

const RewardableBlocksModal = ({ onClose, onChangeBlocksData }) => {
    const { t } = useTranslation()
    const [activeView, setActiveView] = useState(null)
    const [unrewardableBlocks, setUnrewardableBlocks] = useState([])

    const {
        project: { projectStructureJson },
    } = useContext(ProjectContext)

    useEffect(() => {
        const rewardableBlocks = findBlocksWithKeyValue(projectStructureJson, SCHEMA_KEY.isRewardable, true)
        if (!!rewardableBlocks.length) {
            onClose()
            return
        }
        const blocks = findBlocksWithKeyValue(projectStructureJson, SCHEMA_KEY.isRewardable, false)
        if (blocks.length === 0) {
            setActiveView(VIEW.NO_BLOCKS)
        } else if (blocks.length === 1) {
            setActiveView(VIEW.ONE_BLOCK)
        } else if (blocks.length > 1) {
            setActiveView(VIEW.MANY_BLOCKS)
        }
        setUnrewardableBlocks(blocks)
    }, [])

    const onActivate = () => {
        const block = unrewardableBlocks[0]
        onChangeBlocksData({
            [block.id]: {
                data: { [SCHEMA_KEY.isRewardable]: true },
            },
        })
        onClose()
    }

    if (!activeView) return null

    return (
        <Modal onClose={onClose}>
            <div className={styles.rewardableBlocksModal}>
                <h4 className={styles.title}>
                    {activeView === VIEW.NO_BLOCKS && t('Your reward list is ready')}
                    {activeView === VIEW.ONE_BLOCK &&
                        t('Activate reward giveaway for “{{blockName}}”?', {
                            blockName: BLOCK_DICTIONARY[unrewardableBlocks[0].t].label,
                        })}
                    {activeView === VIEW.MANY_BLOCKS && t('Your reward list is ready')}
                </h4>
                <p className={styles.text}>
                    {activeView === VIEW.NO_BLOCKS &&
                        t(
                            'All set! Now create a compatible game block (for example, Wheel of Fortune, Quiz, or Crossword) and activate the reward giveaway for it.',
                        )}
                    {activeView === VIEW.ONE_BLOCK &&
                        t(
                            'We found a compatible game block in your project — “{{blockName}}”. Do you want to activate the reward giveaway for it now? You can always link it later in the game settings.',
                            { blockName: BLOCK_DICTIONARY[unrewardableBlocks[0].t].label },
                        )}
                    {activeView === VIEW.MANY_BLOCKS &&
                        t(
                            'Now choose the game blocks you want to use for the reward giveaway and activate it in their settings.',
                        )}
                </p>
                <div className={styles.buttons}>
                    {[VIEW.NO_BLOCKS, VIEW.MANY_BLOCKS].includes(activeView) && (
                        <button className=" button" data-size="md" data-variant="primary" onClick={onClose}>
                            {t('All clear')}
                        </button>
                    )}
                    {activeView === VIEW.ONE_BLOCK && (
                        <>
                            <button className="button" data-size="md" data-variant="secondary" onClick={onClose}>
                                {t('Do it later')}
                            </button>
                            <button className=" button" data-size="md" data-variant="primary" onClick={onActivate}>
                                {t('Activate now')}
                            </button>
                        </>
                    )}
                </div>
            </div>
        </Modal>
    )
}

export default RewardableBlocksModal
